export default {
  "zh-CN": {
    splash: {
      headline: "打开全新世界"
    },
    install: {
      title: "安装 StarLive",
      description: "添加到主屏幕后，可获得更完整、更沉浸的 App 使用体验。",
      close: "关闭安装引导",
      step1: "点击 Safari 工具栏中的分享按钮。",
      step2: "在菜单中选择「添加到主屏幕」。",
      step3: "确认名称为 StarLive，然后点击「添加」。",
      confirm: "我知道了",
      settingsTitle: "安装 StarLive",
      settingsTip: "查看 iPhone 或 Android 主屏幕安装方法",
      androidDescription: "把 StarLive 安装到主屏幕，之后可像普通 App 一样独立打开。",
      androidReady: "当前浏览器已准备好系统安装窗口。",
      androidFallback: "请打开浏览器菜单，选择「安装应用」或「添加到主屏幕」。",
      androidAction: "安装到主屏幕",
      installing: "正在打开安装窗口"
    },
    update: {
      title: "发现新版本",
      description: "为了获得最新功能和修复，请刷新 StarLive。",
      updating: "正在更新并准备重新打开…",
      later: "稍后",
      action: "立即更新"
    },
    network: {
      offline: "当前网络不可用，正在显示可用的缓存内容",
      restored: "网络已恢复"
    }
  },
  "en-US": {
    splash: {
      headline: "Open a new world"
    },
    install: {
      title: "Install StarLive",
      description: "Add StarLive to your Home Screen for a more complete, immersive app experience.",
      close: "Close installation guide",
      step1: "Tap the Share button in the Safari toolbar.",
      step2: "Choose “Add to Home Screen” from the menu.",
      step3: "Confirm the name StarLive, then tap “Add”.",
      confirm: "Got it",
      settingsTitle: "Install StarLive",
      settingsTip: "View iPhone or Android Home Screen installation steps",
      androidDescription: "Install StarLive on your Home Screen and open it later like a regular app.",
      androidReady: "Your browser is ready to show the system install prompt.",
      androidFallback: "Open the browser menu and choose “Install app” or “Add to Home screen”.",
      androidAction: "Install on Home Screen",
      installing: "Opening install prompt"
    },
    update: {
      title: "A new version is ready",
      description: "Refresh StarLive to get the latest features and fixes.",
      updating: "Updating and preparing to reopen…",
      later: "Later",
      action: "Update now"
    },
    network: {
      offline: "You're offline. Showing available cached content.",
      restored: "Back online"
    }
  },
  "vi-VN": {
    splash: {
      headline: "Mở ra một thế giới mới"
    },
    install: {
      title: "Cài đặt StarLive",
      description: "Thêm StarLive vào Màn hình chính để có trải nghiệm ứng dụng đầy đủ và sống động hơn.",
      close: "Đóng hướng dẫn cài đặt",
      step1: "Chạm vào nút Chia sẻ trên thanh công cụ Safari.",
      step2: "Chọn “Thêm vào Màn hình chính” trong menu.",
      step3: "Xác nhận tên StarLive rồi chạm vào “Thêm”.",
      confirm: "Đã hiểu",
      settingsTitle: "Cài đặt StarLive",
      settingsTip: "Xem cách cài đặt lên Màn hình chính của iPhone hoặc Android",
      androidDescription: "Cài StarLive lên Màn hình chính để mở độc lập như một ứng dụng thông thường.",
      androidReady: "Trình duyệt đã sẵn sàng mở cửa sổ cài đặt hệ thống.",
      androidFallback: "Mở menu trình duyệt rồi chọn “Cài đặt ứng dụng” hoặc “Thêm vào Màn hình chính”.",
      androidAction: "Cài lên Màn hình chính",
      installing: "Đang mở cửa sổ cài đặt"
    },
    update: {
      title: "Đã có phiên bản mới",
      description: "Hãy làm mới StarLive để nhận các tính năng và bản sửa lỗi mới nhất.",
      updating: "Đang cập nhật và chuẩn bị mở lại…",
      later: "Để sau",
      action: "Cập nhật ngay"
    },
    network: {
      offline: "Mạng hiện không khả dụng. Đang hiển thị nội dung đã lưu.",
      restored: "Đã kết nối lại mạng"
    }
  },
  "ar-SA": {
    splash: {
      headline: "افتح عالماً جديداً"
    },
    install: {
      title: "تثبيت StarLive",
      description: "أضف StarLive إلى الشاشة الرئيسية للحصول على تجربة تطبيق أكثر اكتمالًا وانغماسًا.",
      close: "إغلاق دليل التثبيت",
      step1: "اضغط زر المشاركة في شريط أدوات Safari.",
      step2: "اختر «إضافة إلى الشاشة الرئيسية» من القائمة.",
      step3: "تأكد من أن الاسم StarLive ثم اضغط «إضافة».",
      confirm: "فهمت",
      settingsTitle: "تثبيت StarLive",
      settingsTip: "اعرض خطوات التثبيت على شاشة iPhone أو Android الرئيسية",
      androidDescription: "ثبّت StarLive على الشاشة الرئيسية وافتحه لاحقًا كتطبيق مستقل.",
      androidReady: "المتصفح جاهز لعرض نافذة التثبيت الخاصة بالنظام.",
      androidFallback: "افتح قائمة المتصفح واختر «تثبيت التطبيق» أو «إضافة إلى الشاشة الرئيسية».",
      androidAction: "التثبيت على الشاشة الرئيسية",
      installing: "جارٍ فتح نافذة التثبيت"
    },
    update: {
      title: "يتوفر إصدار جديد",
      description: "حدّث StarLive للحصول على أحدث الميزات والإصلاحات.",
      updating: "جارٍ التحديث والاستعداد لإعادة الفتح…",
      later: "لاحقًا",
      action: "التحديث الآن"
    },
    network: {
      offline: "لا يتوفر اتصال بالشبكة. يتم عرض المحتوى المحفوظ المتاح.",
      restored: "تمت استعادة الاتصال"
    }
  }
}
